module.exports = __webpack_public_path__ + "static/media/relay-change.9407a4e7.svg";